'use strict';

//Fetch module (defined in app.js)
angular.module('App.v1.Services')

	//******************** SERVICES *****************************************************************
	.factory('App.v1.Services.User', ['$resource', '$filter',
		function ($resource, $filter) {
			return $resource(
				'/api/user',
				{},
				{
					'get': { method: 'GET', isArray: false }
				}
			);
		}]);